import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import React from 'react'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { OBJECT_TYPES, ObjectTypeKey } from '../../constants/objectTypes'

interface ObjectDisplayProps {
  objectType: ObjectTypeKey | string
  iconSize?: number
  showText?: boolean
  textStyle?: React.CSSProperties
  iconColor?: string
  label?: string
}

export function ObjectDisplay({
  objectType,
  iconSize = 14,
  showText = true,
  textStyle,
  iconColor,
  label,
}: ObjectDisplayProps) {
  const objectConfig = OBJECT_TYPES[objectType as ObjectTypeKey]
  const Icon = objectConfig?.icon || AiOutlineQuestionCircle
  const displayColor = iconColor || 'var(--theme-color-1)'

  if (!showText) {
    return <Icon size={iconSize} style={{ color: displayColor }} />
  }

  return (
    <Horizontal
      gap={6}
      alignItems='center'
      style={{ minWidth: 0, lineHeight: 1 }}
    >
      <Icon size={iconSize} style={{ color: displayColor, flexShrink: 0 }} />
      <Texto category='p1' style={{ lineHeight: 1, ...textStyle }}>
        {label || objectConfig?.name || objectType}
      </Texto>
    </Horizontal>
  )
}
